import localStorage from "../utils/localStorage"
import { PRIVACY_TYPES } from "../store/enums"
import { QB_GROUPID, QB_BUSID } from "../constants/langs"
import * as helper from "../utils/helper"
import { getAuthPrivacy, PrivacyAuthStatus } from "../api/privacy"
import { getParam } from "../utils/url"

export enum privacyEnums {
  agree = PRIVACY_TYPES.agree,
  disagree = PRIVACY_TYPES.disagree
}

type privacyInfoType = {
  [index: string]: privacyEnums
}

export const privacyKey = "txcz_user_privacy"

// window 上也存存一份是为了避免读ls失败导致重复跳转的问题
window[privacyKey] = null

/**
 * 获得授权时的groupId
 * 没有时，默认是76
 * @param groupId
 */
export function getAuthGroupId(groupId: string | number): string | number {
  return groupId || QB_GROUPID
}

export function getAuthBusId(busId: string | number): string | number {
  return busId || QB_BUSID
}

/**
 * 判断当前是否是QB业务
 * @param groupId
 */
export function isQbGroupId(groupId: string | number): boolean {
  return groupId == QB_GROUPID
}

/**
 * 获得用户隐私协议
 */
export function getUserPrivacy(): privacyInfoType {
  if (window[privacyKey] && Object.keys(window[privacyKey])) {
    return window[privacyKey]
  }
  return localStorage.get(privacyKey, true) || {}
}

/**
 * 判断用户是否是同意状态
 * @param groupId
 * @param busId
 * @param type  // 用来做相同业务下不同场景 授权隔离
 * 如果带了屏蔽个保的参数，则直接返回已同意
 */
export function checkIfUserAgreed(groupId: string | number, busId: string | number = "", type?: string): boolean {
  if (getParam("disablePrivacy")) {
    return true
  }

  const agreedStatus = getUserPrivacyByGroupId(groupId)

  if (busId) {
    const bizAgreeStatus = getUserPrivacyByGroupId(`${groupId}_${busId}${type ? `_${type}` : ""}`)
    if (!bizAgreeStatus && !type) {
      return agreedStatus == PRIVACY_TYPES.agree
    } else {
      return bizAgreeStatus == PRIVACY_TYPES.agree
    }
  } else {
    return agreedStatus === PRIVACY_TYPES.agree
  }
}

/**
 * 根据groupId判断用户是否同意了隐私协议
 * @param groupId
 */
export function getUserPrivacyByGroupId(groupId: string | number): privacyEnums | string {
  const userPrivacyInfo = getUserPrivacy()

  return userPrivacyInfo[groupId] || ""
}

/**
 * 设置用户协议
 * @param privacyInfo 
 *  之前用业务组id授权
 * {
      [groupId]: PRIVACY_TYPES.agree
    }
 *  改为业务id授权
 * {
      [`${groupId}_${busId}`]: PRIVACY_TYPES.agree
    }
 */
export function setPrivacyByGroupIds(privacyInfo: privacyInfoType): void {
  if (!privacyInfo) {
    return
  }

  let userPrivacyInfo = getUserPrivacy()

  userPrivacyInfo = {
    ...userPrivacyInfo,
    ...privacyInfo
  }

  window[privacyKey] = userPrivacyInfo
  localStorage.set(privacyKey, JSON.stringify(userPrivacyInfo))
}

/**
 * 判断调用授权cgi时，参数是否正确
 * @param loginState
 * 需要不为第三方登录态时，再去掉接口
 */
export function checkCgiParams(loginState): boolean {
  return (
    ["st_dummy", "st_local_third_party", "st_third_party"].indexOf(loginState?.sessionType) === -1 &&
    loginState?.sessionType &&
    loginState?.openid
  )
}

/**
 * 设置用户的
 * @param sandbox
 * @param offerId
 * @param loginState
 */
export async function setUserPrivacy({ sandbox, offerId, loginState }): Promise<any> {
  let userPrivacy: Array<PrivacyAuthStatus> = []

  // 无登录态可以不用调用接口
  if (checkCgiParams(loginState)) {
    try {
      userPrivacy = await getAuthPrivacy({
        sandbox,
        offerId,
        loginState: helper.getLoginState(loginState)
      })
    } catch (err) {
      console.log("err", err)
    }
  }

  const userPrivacyMap = {}

  if (userPrivacy?.length) {
    userPrivacy.forEach(item => {
      userPrivacyMap[item.groupId.toString()] = item.authorized ? PRIVACY_TYPES.agree : PRIVACY_TYPES.disagree
    })
  }

  setPrivacyByGroupIds(userPrivacyMap)
}

/**
 * 异步调用隐私协议
 * @param store
 */
export function setUserPrivacyAsync(store): void {
  const { sandbox, offerId, loginState } = store.getters

  if (!window[privacyKey]) {
    setUserPrivacy({
      sandbox,
      offerId,
      loginState
    })
  }
}

// 当前pf下的授权管理配置
export function getAuthManageItem(currentItem: { authManageList: any[] }, pf: string): any {
  return currentItem?.authManageList?.find(item => {
    const pfList = item.pf?.split(";")
    return pfList?.find(s => pf.indexOf(s) > -1)
  })
}
export function getAuthManageItemKey(currentItem: { authManageList: any[] }, pf: string): string | undefined {
  return getAuthManageItem(currentItem, pf)?.key
}

const USERREFUSEAUTH = "txcz_user_refuse_auth"
// 记录临时点击授权的状态
export function getTempAuthStatus(keyStr: string | number): boolean {
  try {
    let session = sessionStorage.getItem(USERREFUSEAUTH)
    if (!session) {
      return false
    }
    session = JSON.parse(session)
    return session?.[keyStr]
  } catch (error) {
    return false
  }
}

export function setTempAuthStatus(keyStr: string, value: any): void {
  try {
    const session = sessionStorage.getItem(USERREFUSEAUTH)
    let sessionObj = {
      [keyStr]: value
    }
    if (session) {
      const obj = JSON.parse(session) || {}
      sessionObj = {
        ...obj,
        ...sessionObj
      }
    }
    sessionStorage.setItem(USERREFUSEAUTH, JSON.stringify(sessionObj))
  } catch (error) {
    console.log(error)
  }
}
